import PropTypes from "prop-types"
import React, { useMemo } from "react"

import moment from "moment"
import WeekGrid from "./WeekGrid"
import CrewWeekGrid from "./CrewWeekGrid"
import EquipmentWeekGrid from "./EquipmentWeekGrid"
import DayGrid from "./DayGrid"
import { DEFAULT_END_HOUR, DEFAULT_START_HOUR } from "../../constants"

const CalendarTimeGrid = ({ date, events = [], type, resources, agenda, activeTab, crewIds, equipmentIds, categoryIds, roleIds }) => {
  const hours = Array.from({ length: DEFAULT_END_HOUR - DEFAULT_START_HOUR + 1 }, (_, i) => DEFAULT_START_HOUR + i)
  const weekStartDate = useMemo(() => moment(date).clone().day(0).startOf("day"), [date])
  const weekEndDate = useMemo(() => moment(date).clone().day(6).startOf("day"), [date])

  const calendarDaysCount = useMemo(() => weekEndDate.diff(weekStartDate, "days") + 1, [weekStartDate, weekEndDate])
  const calendarDays = useMemo(
    () => new Array(calendarDaysCount).fill().map((_, index) => weekStartDate.clone().add(index, "days")),
    [weekStartDate, calendarDaysCount]
  )

  // Crew/Equipment tabs never use agenda (time-grid) view
  if (type === "week" && activeTab === 'crew') {
    return <CrewWeekGrid calendarDays={calendarDays} events={events} crewIds={crewIds} roleIds={roleIds} />;
  }
  if (type === "week" && activeTab === 'equipment') {
    return <EquipmentWeekGrid calendarDays={calendarDays} events={events} equipmentIds={equipmentIds} categoryIds={categoryIds} />;
  }
  if (type === "week") {
    // My Bookings always shows the time-grid; when empty default to 12 AM–12 PM
    const myBookingsEmpty = activeTab === 'my-bookings' && events.length === 0
    const myBookingsHours = Array.from({ length: 13 }, (_, i) => i) // 0–12
    const showAgenda = activeTab === 'my-bookings' ? true : agenda
    const gridHours = myBookingsEmpty ? myBookingsHours : hours
    return <WeekGrid calendarDays={calendarDays} hours={gridHours} events={events} agenda={showAgenda} />;
  }
  return <DayGrid date={date} calendarDays={calendarDays} hours={hours} events={events} resources={resources} profileIds={crewIds} boatIds={equipmentIds} activeTab={activeTab} />;
}

CalendarTimeGrid.propTypes = {
  type: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  resources: PropTypes.array,
  agenda: PropTypes.bool,
  activeTab: PropTypes.string,
  crewIds: PropTypes.array,
  equipmentIds: PropTypes.array,
  categoryIds: PropTypes.array,
  roleIds: PropTypes.array,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      start: PropTypes.number,
      end: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string
    })
  )
}

export default CalendarTimeGrid
